<template>
  <aside class="sidebar" id="sidebar" :class="{ 'sidebar-collapsed': collapsed, 'mobile-open': mobileOpen }">
    <!-- 头部 -->
    <div class="sidebar-header">
      <div class="sidebar-logo-row">
        <div class="sidebar-logo">
          <img v-if="siteLogo" :src="siteLogo" :alt="siteName" style="height:80px;width:240px;object-fit:contain">
          <span v-else>{{ siteName || 'AI Gateway' }}</span>
        </div>

      </div>
      <div class="sidebar-search">
        <span class="search-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg></span>
        <input type="text" id="sidebar-search" v-model="searchQuery" placeholder="搜索对话…" @input="onSearch">
      </div>
      <div class="sidebar-header-actions">
        <button class="btn-new-chat" id="btn-new-chat" @click="newChat">+ 新建对话</button>
        <button class="btn-collapse-sidebar" title="折叠侧栏" @click="toggleCollapse">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>
        </button>
      </div>
    </div>

    <!-- 模式列表 -->
    <div class="mode-list" id="mode-list">
      <button class="mode-item" :class="{ active: globalMode === 'chat' }" data-mode="chat" @click="setGlobalMode('chat')">
        <svg class="mode-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        对话
      </button>

      <!-- AI创作折叠菜单 -->
      <div class="mode-folder" id="mode-folder-create" :class="{ open: globalMode === 'create' || createFolderOpen }">
        <button class="mode-item mode-folder-toggle" data-mode="create" @click="toggleModeFolder">
          <svg class="mode-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>
          <span class="mode-folder-text">AI创作</span>
          <span class="mode-folder-arrow"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m9 18 6-6-6-6"/></svg></span>
        </button>
        <div class="mode-submenu" id="mode-submenu-create">
          <button class="mode-subitem" :class="{ active: globalMode === 'create' && currentCreateTab === 'text2img' }" data-ctab="text2img" @click="selectCreateTab('text2img')">
            <svg class="mode-subitem-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            文生图
          </button>
          <button class="mode-subitem" :class="{ active: globalMode === 'create' && currentCreateTab === 'img2img' }" data-ctab="img2img" @click="selectCreateTab('img2img')">
            <svg class="mode-subitem-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
            图生图
          </button>
          <button class="mode-subitem" :class="{ active: globalMode === 'create' && currentCreateTab === 'video' }" data-ctab="video" @click="selectCreateTab('video')">
            <svg class="mode-subitem-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/><line x1="17" y1="17" x2="22" y2="17"/></svg>
            文生视频
          </button>
          <button class="mode-subitem" :class="{ active: globalMode === 'create' && currentCreateTab === 'video_i2v' }" data-ctab="video_i2v" @click="selectCreateTab('video_i2v')">
            <svg class="mode-subitem-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="22" height="18" rx="2" ry="2"/><polygon points="23 7 16 12 23 17 23 7"/><circle cx="8" cy="13" r="3"/><path d="m1 21 5-5-3-3"/></svg>
            图生视频
          </button>
        </div>
      </div>

      <button class="mode-item" :class="{ active: globalMode === 'debate' }" data-mode="debate" @click="setGlobalMode('debate')">
        <svg class="mode-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="3" x2="12" y2="8"/><circle cx="12" cy="13" r="4"/><line x1="8" y1="21" x2="16" y2="21"/><path d="M22 17l-3-3"/></svg>
        深度思辨
      </button>

      <button class="mode-item" :class="{ active: globalMode === 'zen' }" data-mode="zen" @click="setGlobalMode('zen')">
        <svg class="mode-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></svg>
        禅模式
      </button>

      <button class="mode-item" @click="$emit('open-shares')">
        <svg class="mode-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
        我的分享
      </button>

      <button class="mode-item" @click="$emit('open-gallery')">
        <svg class="mode-item-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
        创作成果
      </button>
    </div>

    <!-- 历史记录 -->
    <div class="sidebar-history" id="history-list">
      <div class="history-empty" v-if="renderedHistory.length === 0">
        <span v-html="searchQuery ? '未找到匹配的对话' : conversations.length === 0 ? '暂无对话记录<br>开始你的第一次对话吧' : '加载中…'"></span>
      </div>
      <template v-else>
        <div class="history-group" v-for="group in renderedHistory" :key="group.label">
          <div class="history-group-label">{{ group.label }}</div>
          <div
            v-for="conv in group.items"
            :key="conv.group_id || conv.request_id"
            class="history-item"
            :class="{ active: (conv.group_id || conv.request_id) === currentConvId, pinned: conv.is_pinned == 1, bookmarked: conv.is_bookmarked == 1 }"
            :data-id="conv.group_id || conv.request_id"
            :data-request-id="conv.request_id"
            :data-bookmarked="conv.is_bookmarked == 1 ? '1' : '0'"
            :data-pinned="conv.is_pinned == 1 ? '1' : '0'"
            :data-is-creation="isCreation(conv.roles) ? '1' : '0'"
            @click="selectConversation(conv.group_id || conv.request_id)"
            @contextmenu.prevent="showConvMenu($event, conv.group_id || conv.request_id)"
          >
            <span class="item-icon" v-html="getConvIcon(conv)"></span>
            <span class="item-text" :data-gid="conv.group_id || conv.request_id" @dblclick.stop="startEditTitle($event, conv.group_id || conv.request_id)">{{ getConvTitle(conv) }}</span>
            <button class="item-menu" title="更多" @click.stop="showConvMenu($event, conv.group_id || conv.request_id)">⋯</button>
          </div>
        </div>
      </template>
    </div>

    <!-- 底部：个人中心折叠面板 -->
    <div class="sidebar-footer">
      <div class="fold-panel" id="fold-personal" :class="{ open: personalOpen }">
        <button class="fold-toggle personal-fold-toggle" @click="personalOpen = !personalOpen">
          <span class="fold-arrow"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m9 18 6-6-6-6"/></svg></span>
          <!-- 头像 -->
          <div class="personal-fold-avatar">
            <img v-if="userAvatar" :src="userAvatar" class="personal-fold-avatar-img" />
            <div v-else class="personal-fold-avatar-fallback">{{ userInitial }}</div>
          </div>
          <span class="personal-fold-name">{{ userDisplayName || portal.state.user?.username || '未登录' }}</span>
          <span class="guest-badge" v-if="portal.isDemo.value">演示只读</span>
          <span class="guest-badge" v-else-if="!portal.isLoggedIn.value">访客</span>
        </button>
        <div class="fold-menu">
          <button class="fold-menu-item" id="btn-profile" @click="$emit('openProfile')">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/></svg></span> 个人中心
          </button>
          <button class="fold-menu-item" id="btn-settings" @click="$emit('openSettings')">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg></span> 设置
          </button>
          <button class="fold-menu-item" id="btn-help" @click="$emit('openContentPage', 'help')">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></span> 帮助与反馈
          </button>
          <button class="fold-menu-item" id="btn-download" @click="window.open(CFG.DOWNLOAD_URL || '#')">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg></span> 下载移动版
          </button>
          <button class="fold-menu-item" id="btn-admin" :style="{ display: portal.isAdmin.value ? '' : 'none' }" @click="goToAdmin">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg></span> 后台管理
          </button>
          <button class="fold-menu-item" id="btn-logout" :style="{ display: portal.isLoggedIn.value ? '' : 'none' }" @click="handleLogout">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16,17 21,12 16,7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span> 退出登录
          </button>
          <button class="fold-menu-item" id="btn-login" :style="{ display: portal.isLoggedIn.value ? 'none' : '' }" @click="showLoginFn()">
            <span class="menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10,17 15,12 10,7"/><line x1="15" y1="12" x2="3" y2="12"/></svg></span> 登录
          </button>
        </div>
      </div>
      <div class="site-footer-info" id="site-footer" v-html="footerHtml"></div>
    </div>

    <!-- 折叠后的迷你图标列 -->
    <div class="sidebar-collapsed-icons" id="sidebar-collapsed-icons">
      <button class="collapsed-icon-btn" title="展开侧栏" @click="toggleCollapse">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>
      </button>
      <button class="collapsed-icon-btn" title="搜索对话" @click="focusSearch">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
      </button>
      <button class="collapsed-icon-btn" title="新建对话" @click="newChat">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      </button>
      <button class="collapsed-icon-btn" title="个人中心" @click="personalOpen = !personalOpen">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/></svg>
      </button>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, inject } from 'vue'
import { usePortal } from '@/stores/portal'
import { globalToast } from '@/composables/useToast'
import { PORTAL_CONFIG } from '@/config'

const portal = usePortal()
const CFG = PORTAL_CONFIG

const emit = defineEmits<{
  (e: 'openSettings'): void
  (e: 'openProfile'): void
  (e: 'openContentPage', type: 'terms' | 'privacy' | 'help'): void
  (e: 'showLogin'): void
  (e: 'openCreativeDetail', item: any): void
  (e: 'open-shares'): void
  (e: 'open-gallery'): void
}>()

// 显示登录弹窗的函数（由 App.vue 注入）
const showLoginFn = inject<(message?: string, title?: string) => void>('showLogin', () => {})

// =========== State ===========
const collapsed = ref(false)
const mobileOpen = ref(false)
const personalOpen = ref(false)
const createFolderOpen = ref(false)
const searchQuery = ref('')
const currentConvId = ref<string | null>(null)
const conversations = ref<any[]>([])
const currentCreateTab = ref('text2img')
let searchTimer: any = null

// 用户头像/名字（从 store 全局状态读取，与个人中心同步）
const userAvatar = computed(() => portal.state.userAvatar || '')
const userDisplayName = computed(() => portal.state.userDisplayName || '')
const userInitial = computed(() => {
  const name = userDisplayName.value || '?'
  return name.charAt(0).toUpperCase()
})

// =========== Computed ===========
const siteName = computed(() => CFG.SITE_NAME || '')
const siteLogo = computed(() => CFG.SITE_LOGO || '')
const globalMode = computed(() => portal.state.globalMode || 'chat')

const footerHtml = computed(() => {
  const name = siteName.value
  const copyright = name ? `© ${name}` : ''
  return `${copyright} · 合作：<a href="mailto:yoyo@seqvec.com">yoyo@seqvec.com</a>`
})

const renderedHistory = computed(() => {
  let filtered = conversations.value
  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase()
    filtered = filtered.filter((c: any) =>
      (c.user_message || '').toLowerCase().includes(q) ||
      (c.summary_keywords || '').toLowerCase().includes(q) ||
      (c.roles || '').toLowerCase().includes(q)
    )
  }

  // Group by date (use local time, not UTC)
  const groups: Record<string, any[]> = {}
  const now = new Date()
  const pad2 = (n: number) => String(n).padStart(2, '0')
  const today = `${now.getFullYear()}-${pad2(now.getMonth()+1)}-${pad2(now.getDate())}`
  const yesterdayDate = new Date(now.getTime() - 86400000)
  const yesterday = `${yesterdayDate.getFullYear()}-${pad2(yesterdayDate.getMonth()+1)}-${pad2(yesterdayDate.getDate())}`

  filtered.forEach((c: any) => {
    const d = c.created_at?.split(' ')[0] || today
    let key: string
    if (d === today) key = '今天'
    else if (d === yesterday) key = '昨天'
    else key = '更早'
    if (!groups[key]) groups[key] = []
    groups[key].push(c)
  })

  const result: { label: string; items: any[] }[] = []
  for (const label of ['今天', '昨天', '更早']) {
    if (groups[label]?.length) {
      result.push({ label, items: groups[label] })
    }
  }
  return result
})

// =========== Methods ===========
const CREATE_KEYS = ['text2img', 'img2img', 'video', 'video_create', 'video_gen']
const ZEN_KEY = 'zen_master'
const DEBATE_KEYS = ['debate_calibrator', 'debate_left', 'debate_right']

function isCreation(roles: string | null) {
  if (!roles) return false
  return CREATE_KEYS.some(k => roles.split(',').includes(k))
}

function escHtml(s: any) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

function getConvTitle(conv: any) {
  return conv.title || (conv.user_message || '新对话').replace(/\s*\[图\/文件：[^\]]*\]/g, '').substring(0, 40)
}

const SB_SVG = {
  pin: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="17" x2="12" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/></svg>',
  star: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
}
function getConvIcon(conv: any) {
  if (conv.is_pinned == 1) return SB_SVG.pin
  if (conv.is_bookmarked == 1) return SB_SVG.star
  const roles = (conv.roles || '').split(',')
  if (roles.includes(ZEN_KEY)) {
    return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></svg>'
  }
  if (isCreation(conv.roles)) {
    return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>'
  }
  return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>'
}

// ---- History ----
async function loadHistory() {
  try {
    const data = await portal.apiGet('dashboard.php', { action: 'conversations', per_page: 100 })
    conversations.value = data.data || []
  } catch (e) {
    conversations.value = []
  }
  // No need to re-render — computed does it automatically
}

function clearCurrentConv() {
  currentConvId.value = null
}

function selectConversation(groupId: string) {
  currentConvId.value = groupId

  const conv = conversations.value.find((c: any) => (c.group_id || c.request_id) === groupId)
  const roles = (conv?.roles || '').split(',')
  const isCreationConv = roles.some((r: string) => CREATE_KEYS.includes(r))
  const isZenConv = roles.some((r: string) => r === ZEN_KEY)
  const isDebateConv = roles.some((r: string) => DEBATE_KEYS.includes(r))

  if (isCreationConv) {
    const tab = roles[0] && CREATE_KEYS.includes(roles[0]) ? roles[0] : 'text2img'
    currentCreateTab.value = tab
    createFolderOpen.value = true
    portal.state.globalMode = 'create'
    ;(window as any).setGlobalMode?.('create')
    ;(window as any).switchCreateTab?.(tab)
    ;(window as any).__loadCreationHistory?.(groupId)
  } else if (isZenConv) {
    // 禅模式对话：直接进入禅模式（不弹确认窗），然后加载对话
    if (portal.state.globalMode !== 'zen') {
      ;(window as any).enterZenDirect?.()
    }
    // 延迟加载确保 DOM 切换完成
    setTimeout(() => {
      ;(window as any).__loadConversation?.(groupId)
    }, 100)
  } else if (isDebateConv && globalMode.value !== 'debate') {
    portal.state.globalMode = 'debate'
    ;(window as any).setGlobalMode?.('debate')
    ;(window as any).__loadConversation?.(groupId)
  } else {
    if (globalMode.value !== 'chat') {
      portal.state.globalMode = 'chat'
      ;(window as any).setGlobalMode?.('chat')
    }
    ;(window as any).__loadConversation?.(groupId)
  }
}

function newChat() {
  currentConvId.value = null
  portal.state.currentRequestId = null
  portal.newConversationId()
  ;(window as any).__clearChat?.()
  ;(window as any).__newChat?.()
}

// ---- Search ----
function onSearch() {
  clearTimeout(searchTimer)
  searchTimer = setTimeout(() => {
    // Computed auto-filters based on searchQuery
  }, 250)
}

function focusSearch() {
  document.getElementById('sidebar-search')?.focus()
}

// ---- Title Edit ----
function startEditTitle(event: MouseEvent, groupId: string) {
  const span = event.target as HTMLSpanElement
  const currentText = span.textContent?.trim() || ''
  if (span.querySelector('input')) return

  const input = document.createElement('input')
  input.type = 'text'
  input.value = currentText === '新对话' ? '' : currentText
  input.maxLength = 40
  input.className = 'title-edit-input'
  Object.assign(input.style, {
    width: '100%', border: 'none', outline: 'none', background: 'transparent',
    fontSize: 'inherit', color: 'inherit', padding: '0', margin: '0', fontFamily: 'inherit',
  })

  span.textContent = ''
  span.appendChild(input)
  input.focus()
  input.select()

  const save = async () => {
    const newTitle = input.value.trim()
    span.removeChild(input)
    span.appendChild(document.createTextNode(newTitle || currentText || '新对话'))

    if (newTitle === currentText) return
    try {
      const token = portal.getToken()
      const url = (CFG.API_BASE || '') + '/api/dashboard.php?action=update_title'
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ group_id: groupId, title: newTitle }),
      })
      if (!res.ok) throw new Error('更新失败')
      const data = await res.json()
      const conv = conversations.value.find((c: any) => (c.group_id || c.request_id) === groupId)
      if (conv) conv.title = data.title
      // Trigger reactive update
      conversations.value = [...conversations.value]
    } catch (e: any) {
      globalToast('标题更新失败: ' + e.message, 'error')
      span.textContent = currentText || '新对话'
    }
  }

  input.addEventListener('blur', save)
  input.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Enter') { e.preventDefault(); input.blur() }
    if (e.key === 'Escape') {
      e.preventDefault()
      span.removeChild(input)
      span.appendChild(document.createTextNode(currentText || '新对话'))
    }
  })
}

// ---- Context Menu ----
function showConvMenu(e: MouseEvent, groupId: string) {
  const conv = conversations.value.find((c: any) => (c.group_id || c.request_id) === groupId)
  const requestId = conv?.request_id || groupId
  const isBookmarked = conv?.is_bookmarked == 1
  const isPinned = conv?.is_pinned == 1

  document.querySelector('.conv-context-menu')?.remove()

  const menu = document.createElement('div')
  menu.className = 'conv-context-menu'
  Object.assign(menu.style, {
    position: 'fixed', zIndex: '300',
    top: e.clientY + 'px', left: (e.clientX - 140) + 'px',
    background: 'var(--bg-secondary)',
    border: '1px solid var(--border-color)',
    borderRadius: 'var(--radius)',
    boxShadow: 'var(--shadow)',
    minWidth: '160px', padding: '4px 0',
  })
  menu.innerHTML = `
    <button class="context-menu-item" data-action="bookmark">${isBookmarked ? SB_SVG.star+' 取消收藏' : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> 收藏对话'}</button>
    <button class="context-menu-item" data-action="pin">${isPinned ? SB_SVG.pin+' 取消置顶' : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg> 置顶对话'}</button>
    <div class="context-menu-divider"></div>
    <button class="context-menu-item" data-action="export"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg> 导出此对话</button>
    <button class="context-menu-item" data-action="hide"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg> 隐藏对话</button>
  `
  ;(menu.querySelectorAll('.context-menu-item') as NodeListOf<HTMLElement>).forEach(btn => {
    Object.assign(btn.style, {
      display: 'block', width: '100%', padding: '8px 14px',
      textAlign: 'left', background: 'none', border: 'none',
      color: 'var(--text-primary)', fontSize: '13px', cursor: 'pointer',
    })
    btn.addEventListener('mouseenter', () => (btn.style.background = 'var(--bg-hover)'))
    btn.addEventListener('mouseleave', () => (btn.style.background = 'none'))
  })
  const divider = menu.querySelector('.context-menu-divider') as HTMLElement
  if (divider) divider.style.cssText = 'height:1px;background:var(--border-color);margin:4px 0;'

  menu.querySelector('[data-action="bookmark"]')?.addEventListener('click', async () => {
    menu.remove()
    await toggleBookmark(groupId, !isBookmarked)
  })
  menu.querySelector('[data-action="pin"]')?.addEventListener('click', async () => {
    menu.remove()
    await togglePin(groupId, !isPinned)
  })
  menu.querySelector('[data-action="export"]')?.addEventListener('click', async () => {
    menu.remove()
    await exportSingleConversation(requestId)
  })
  menu.querySelector('[data-action="hide"]')?.addEventListener('click', async () => {
    menu.remove()
    await hideConversation(requestId)
  })
  document.body.appendChild(menu)

  const closeMenu = (ev: MouseEvent) => {
    if (!menu.contains(ev.target as Node)) {
      menu.remove()
      document.removeEventListener('click', closeMenu)
    }
  }
  setTimeout(() => document.addEventListener('click', closeMenu), 0)
}

async function toggleBookmark(groupId: string, bookmarked: boolean) {
  try {
    await portal.apiPost('dashboard.php?action=bookmark_conversation', {
      group_id: groupId, is_bookmarked: bookmarked ? 1 : 0,
    })
    globalToast(bookmarked ? '已收藏' : '已取消收藏', 'success')
    loadHistory()
  } catch (e: any) {
    globalToast('操作失败: ' + e.message, 'error')
  }
}

async function togglePin(groupId: string, pinned: boolean) {
  try {
    await portal.apiPost('dashboard.php?action=pin_conversation', {
      group_id: groupId, is_pinned: pinned ? 1 : 0,
    })
    globalToast(pinned ? '已置顶' : '已取消置顶', 'success')
    loadHistory()
  } catch (e: any) {
    globalToast('操作失败: ' + e.message, 'error')
  }
}

async function hideConversation(requestId: string) {
  try {
    await portal.apiPost('dashboard.php?action=hide_conversation', { request_id: requestId, is_hidden: 1 })
    globalToast('对话已隐藏', 'success')
    if (currentConvId.value === requestId) newChat()
    loadHistory()
  } catch (e: any) {
    globalToast('操作失败: ' + e.message, 'error')
  }
}

async function exportSingleConversation(requestId: string, format: string = 'html') {
  try {
    const url = (CFG.API_BASE || '') + `/api/dashboard.php?action=export_conversation&format=${format}&request_id=${requestId}`
    const token = portal.getToken()
    const res = await fetch(url, { headers: { 'Authorization': 'Bearer ' + token } })
    if (!res.ok) throw new Error('导出失败')
    const blob = await res.blob()
    const downloadUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = downloadUrl
    const extMap: Record<string, string> = { html: 'html', markdown: 'md', json: 'json', txt: 'txt' }
    a.download = `conversation_export.${extMap[format] || format}`
    a.click()
    URL.revokeObjectURL(downloadUrl)
    globalToast('导出成功', 'success')
  } catch (e: any) {
    globalToast('导出失败: ' + e.message, 'error')
  }
}

// ---- Mode Switching ----
function setGlobalMode(mode: string) {
  // 禅模式走确认弹窗流程
  if (mode === 'zen') {
    ;(window as any).requestZenMode?.()
    return
  }
  portal.state.globalMode = mode
  ;(window as any).setGlobalMode?.(mode)
}

function toggleModeFolder() {
  createFolderOpen.value = !createFolderOpen.value
  if (createFolderOpen.value) {
    setGlobalMode('create')
    ;(window as any).switchCreateTab?.('text2img')
  }
}

function selectCreateTab(tab: string) {
  currentCreateTab.value = tab
  setGlobalMode('create')
  ;(window as any).switchCreateTab?.(tab)
}

// ---- Roles ----
async function loadRoles() {
  try {
    const data = await portal.apiGet('dashboard.php', { action: 'roles' })
    const roles = data.data || []
    portal.state.availableRoles = roles
    const hasDispatcher = roles.some((r: any) => r.role_type === 'dispatcher')
    portal.state.dispatchEnabled = hasDispatcher
    portal.state.autoDispatch = true
  } catch (e) {
    portal.state.dispatchEnabled = false
  }
}

// ---- Logout ----
async function handleLogout() {
  await portal.logout()
  currentConvId.value = null
  conversations.value = []
  setGlobalMode('chat')
  await portal.checkAuth()
  portal.state.userDisplayName = ''
  portal.state.userAvatar = ''
  globalToast('您已退出登录', 'info')
}

// ---- User Profile (for sidebar avatar/name) ----
async function loadUserProfile() {
  await portal.loadUserProfile()
}

// ---- Admin ----  
function goToAdmin() {
  const url = CFG.ADMIN_URL || '../admin/'
  window.location.href = url
}

// ---- Collapse / Mobile ----
function toggleCollapse() {
  collapsed.value = !collapsed.value
  try { localStorage.setItem('portal_sidebar_collapsed', collapsed.value ? '1' : '0') } catch (_) {}
}

function collapse() {
  collapsed.value = true
  try { localStorage.setItem('portal_sidebar_collapsed', '1') } catch (_) {}
}

function expand() {
  collapsed.value = false
  try { localStorage.setItem('portal_sidebar_collapsed', '0') } catch (_) {}
}

function initCollapse() {
  try {
    if (localStorage.getItem('portal_sidebar_collapsed') === '1') {
      collapsed.value = true
    }
  } catch (_) {}
}

function toggleMobile() {
  mobileOpen.value = !mobileOpen.value
}

function mobileCollapseDefault() {
  mobileOpen.value = false
}

function initCreateMode() {
  const savedMode = localStorage.getItem('portal_global_mode') || 'chat'
  if (savedMode === 'create') {
    createFolderOpen.value = true
    currentCreateTab.value = 'text2img'
  }
}

// ---- Expose to parent ----
defineExpose({
  loadHistory,
  loadRoles,
  loadUserProfile,
  clearCurrentConv,
  newChat,
  toggleMobile,
  collapse,
  expand,
  mobileCollapseDefault,
  initCollapse,
  initCreateMode,
  currentConvId,
})

// =========== Init ===========
onMounted(() => {
  initCollapse()
  initCreateMode()
  // Note: loadHistory() and loadRoles() are called from App.vue after checkAuth
})
</script>

<style scoped>
/* 上下文菜单项样式（已在全局 CSS 中定义） */
.guest-badge {
  font-size: 10px;
  color: #999;
  margin-left: auto;
}

/* 个人中心折叠面板：头像 + 名字 */
.personal-fold-toggle {
  display: flex !important;
  align-items: center;
  gap: 8px;
}
.personal-fold-avatar {
  width: 28px; height: 28px; border-radius: 50%;
  overflow: hidden; flex-shrink: 0;
}
.personal-fold-avatar-img {
  width: 100%; height: 100%; object-fit: cover;
}
.personal-fold-avatar-fallback {
  width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700; color: var(--accent);
  background: rgba(79,140,255,0.1);
}
.personal-fold-name {
  font-size: 13px; font-weight: 500;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  max-width: 100px;
}
</style>
